import { useEffect, useState } from "react";
import { fetchPublicLocations } from "../services/publicApi";

export function useLocations() {
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let isMounted = true;

    async function loadLocations() {
      try {
        const data = await fetchPublicLocations();

        if (isMounted) {
          setLocations(Array.isArray(data) ? data : data.results || []);
          setError("");
        }
      } catch (requestError) {
        if (isMounted) {
          setError("Locations are taking a little longer to load.");
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    }

    loadLocations();

    return () => {
      isMounted = false;
    };
  }, []);

  return { locations, loading, error };
}